export default __webpack_public_path__ + "static/media/creation.26765a79.png";